import { StoreRepositoryState } from '@/types';

export default {
  repositories: (state: StoreRepositoryState) => state.list,
  currentRepository: (state: StoreRepositoryState) => state.current,
  currentRepositoryUsers: (state: StoreRepositoryState) => state.current.users,
};
